// animationStore.ts
import { create } from "zustand";

type AnimationState = {
  animatedIds: Set<string>;
  markAnimated: (id: string) => void;
};

export const useAnimationStore = create<AnimationState>((set) => ({
  animatedIds: new Set(),
  markAnimated: (id) =>
    set((state) => {
      const newSet = new Set(state.animatedIds);
      newSet.add(id);
      return { animatedIds: newSet };
    }),
}));
